import styled from 'styled-components';
import { ButtonTag } from '../Button/styles';

export const FormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 25px;
  margin-bottom: 30px;
`;

export const LoginButton = styled(ButtonTag)`
  margin-right: 25px;
  padding: 13px 40px;
`;

export const Message = styled.p`
  margin: 0;
  margin-top: 10px;
  padding: 0;
  
  font-size: 14px;
  color: ${({ theme, type }) => type === 'success' ? theme.green : theme.red};
`;

